import React, { useEffect, useState } from "react";
import { Box, Grid, Link, Tab, Tabs } from "@material-ui/core";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import FilteredTable from "./filteredTable.js";
import mockedData from "./mockeddata.js";
import { getAxiosInstance } from "../../../redux/common";
import {
  getAllCalibrations,
  getFliteredCalibrations,
  removeCalibrationById,
} from "../utils/NetworkHanlder.js";

export default function AllCalibrationPage() {
  const classes = useStyles();
  const [rowData, setRowData] = useState([]);
  const [filters, setFilters] = useState({
    date: "",
    brand: "",
    model: "",
    manufacturer: "",
    calibrator: "",
  });
  const [checkedData, setCheckedData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(2);
  const [numberOfAllElements, setNumberOfAllElements] = useState(0);
  const [page, setPage] = useState(0);
  const headers = ["Data", "Marka", "Model", "OS", "Kalibrator", "Opcje"];

  const removeDeviceHandler = async (deviceId) => {
    const data = removeCalibrationById(deviceId);
    console.log(data);
  };

  const inputHandler = async (event, headerKey) => {
    const { value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [headerKey]: value,
    }));
    if (headerKey !== "date") {
      const queryParams = {
        ...filters,
        pageSize: rowsPerPage,
        page: page,
      };
      queryParams[headerKey] = value;
      const { data } = await getFliteredCalibrations(queryParams);
      setRowData(data.content);
      setNumberOfAllElements(data.totalElements);
    }
    // else if (value && headerKey === "date") {
    // }
  };

  useEffect(() => {
    setCheckedData(new Array(rowData.length).fill(false));
  }, [rowData.length]);

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    const queryParams = {
      ...filters,
      pageSize: rowsPerPage,
      page: newPage,
    };
    const { data } = await getAllCalibrations(queryParams);
    setRowData(data.content);
  };

  const allItemsSelected =
    rowData.length > 0 && checkedData.every((v) => v === true);

  const checkedHandler = (itemIndex) => {
    if (itemIndex === "all") {
      const newCheckedState = !allItemsSelected;
      setCheckedData(new Array(rowData.length).fill(newCheckedState));
    } else {
      const newCheckedData = [...checkedData];
      newCheckedData[itemIndex] = !newCheckedData[itemIndex];
      setCheckedData(newCheckedData);
    }
  };

  const handleChangeRowsPerPage = async (event) => {
    const pageNumber = parseInt(event.target.value, 10);
    setRowsPerPage(pageNumber);
    const queryParams = {
      ...filters,
      pageSize: pageNumber,
      page: 0,
    };
    const { data } = await getAllCalibrations(queryParams);
    setRowData(data.content);
    setPage(0);
  };

  useEffect(() => {
    const init = async () => {
      // const user = {
      //   username: "test2_calibrator@sh200212.website.pl",
      //   password: "AQ@aaaaaaaa1",
      // };
      // await getAxiosInstance().post("/api/auth/login", user);
      const queryParams = {
        pageSize: rowsPerPage,
        page: 0,
      };
      const { data } = await getAllCalibrations(queryParams);
      setNumberOfAllElements(data.totalElements);
      setRowData(data.content);
    };
    init();
  }, []);

  return (
    <Box className={classes.rootContainer}>
      <FilteredTable
        rowData={rowData}
        headers={headers}
        checkedData={checkedData}
        checkedHandler={checkedHandler}
        allItemsSelected={allItemsSelected}
        page={page}
        rowsPerPage={rowsPerPage}
        count={numberOfAllElements}
        inputHandler={inputHandler}
        filters={filters}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        removeHandler={removeDeviceHandler}
      />
    </Box>
  );
}
